export default class authenStatus { 
	constructor(){
		this.isLoggedIn= false;
		this.loggedInSystem= null;
		this.user= null;
		this.requireKyc= true;
	}
};